export default __webpack_public_path__ + "static/media/qr.1a27c447.svg";